export enum PaymentStatus {
  Unpaid = 'UNPAID',
  Paying = 'PAYING',
  Paid = 'PAID',
  Failed = 'FAILED',
  Closed = 'CLOSED',
  Refunding = 'REFUNDING',
  Refunded = 'REFUNDED',
}

export enum PaymentMethod {
  Wechat = 'WECHAT',
  Balance = 'BALANCE',
  Points = 'POINTS',
  GiftCard = 'GIFT_CARD',
}

export const PAYMENT_STATUS_LABELS: Record<PaymentStatus, string> = {
  [PaymentStatus.Unpaid]: '未支付',
  [PaymentStatus.Paying]: '支付中',
  [PaymentStatus.Paid]: '已支付',
  [PaymentStatus.Failed]: '支付失败',
  [PaymentStatus.Closed]: '已关闭',
  [PaymentStatus.Refunding]: '退款中',
  [PaymentStatus.Refunded]: '已退款',
}
